"use client";

import type { FormBlock } from "@mw/shared/payload-types";

import dynamic from "next/dynamic";
import { cn } from "@ui/lib/utils";

import { submitVCApplication } from "@/app/_api/hubspot";

const VCFormDialogButton = dynamic(() => import("@/app/_components/HubspotForms/VCForm/VCFormDialogButton"));
const VCFormLazy = dynamic(() =>
  import("@/app/_components/HubspotForms/VCForm/VCForm").then(mod => ({ default: mod.VCForm })),
);

const ButtonContainer = ({
  children,
  align,
}: {
  children: React.ReactNode;
  align: "center" | "left" | "right" | null | undefined;
}) => {
  return (
    <div
      className={cn("tw-flex tw-mt-8", {
        "tw-justify-center": align === "center",
        "tw-justify-end": align === "right",
      })}
    >
      {children}
    </div>
  );
};

export const BlockFormClient = (props: FormBlock) => {
  const { formConfiguration } = props;
  const isButton = formConfiguration.displayMode === "button";

  switch (formConfiguration.template) {
    case "vc":
      if (isButton) {
        return (
          <ButtonContainer align={formConfiguration.buttonAlign}>
            <VCFormDialogButton
              buttonLabel={formConfiguration.buttonLabel}
              buttonVariant={formConfiguration.buttonVariant ?? undefined}
              buttonSize={formConfiguration.buttonSize ?? undefined}
            />
          </ButtonContainer>
        );
      }
      return <VCFormLazy onSubmit={submitVCApplication} />;
    default:
      return null;
  }
};
